import Head from 'next/head';
import { UAParser } from 'ua-parser-js';
import Button from '@components/atoms/button';
import { BodyRegular, H1 } from '@components/atoms/typography';
import { APP_STORE_URL, GOOGLE_PLAY_URL, WEBSITE_NAME } from '@lib/constants';

const getAppStoreUrl = () => {
  if (typeof window === 'undefined') return;

  const parser = new UAParser();
  const os = parser.getOS();

  if (os.name === 'iOS') {
    return APP_STORE_URL;
  }

  if (os.name === 'Android') {
    return GOOGLE_PLAY_URL;
  }
};

const UnsupportedAppVersion = () => {
  const appStoreUrl = getAppStoreUrl();

  return (
    <>
      <Head>
        <title>{`Update Required | ${WEBSITE_NAME}`}</title>
      </Head>
      <div className="flex flex-col items-center py-10 px-5">
        <H1 className="text-center mt-6">Update required</H1>
        <BodyRegular className="mt-6 text-center max-w-md">
          This version of the app is no longer supported. Please update to the
          latest version to continue.
        </BodyRegular>
        {appStoreUrl && (
          <div className="flex gap-4 mt-8">
            <Button
              href={appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="primary"
            >
              Update app
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default UnsupportedAppVersion;
